module.exports = {
      id: "appstore-usage",
      viewBox: "0 0 120 40",
      url: __webpack_public_path__ + "svg-sprite-e76c2ea32079628f8a8c5156f1fd5f59.svg#appstore",
      toString: function () {
        return this.url;
      }
    }